import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reticencias'
})
export class ReticenciasPipe implements PipeTransform {

  transform(value: string | undefined, maxLength: number): unknown {
    if (!value) return '';

    if (value.length <= maxLength) {
      return value;
    } else {
      return value.substr(0, maxLength) + '...';
    }
  }

}
